export const PAST_LAST_ACTIVE_DATE_ERROR = { value: "pastLastActiveDateError" };
export const LAST_ACTIVE_DATE_ERROR = {value: "lastActiveDateError"};
export const RETROACTIVE_LIMIT_ERROR = { value: "retroactiveLimitError" };
export const LIST_API_HOOK_ERRORS = [PAST_LAST_ACTIVE_DATE_ERROR.value, RETROACTIVE_LIMIT_ERROR.value];
export default [PAST_LAST_ACTIVE_DATE_ERROR, RETROACTIVE_LIMIT_ERROR];



// WEBPACK FOOTER //
// ./src/components/common/enums/apiHooksErrorType.js